import React from 'react';

interface FeatureIconProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export function FeatureIcons() {
  const features = [
    {
      icon: (
        <img
          src="/images/icons/find-your-people.png"
          alt="Find your people"
          className="h-12 w-12"
        />
      ),
      title: 'Find people who share your focus',
      description: 'Join curated tribes based on your role, interests, and goals. Connect with people who are relevant.'
    },
    {
      icon: (
        <img
          src="/images/icons/product-design.png"
          alt="Product, Design, and Engineering"
          className="h-12 w-12"
        />
      ),
      title: 'Turn connections into real relationships',
      description: 'Organise meetups, continue conversations, and stay connected beyond a single interaction.'
    },
    {
      icon: (
        <img
          src="/images/icons/smarter-network.png"
          alt="Smarter network"
          className="h-12 w-12"
        />
      ),
      title: 'A network tailored to what matters to you',
      description: 'Discover discussions, people, and ideas aligned with your interests... not driven by engagement algorithms.'
    }
  ];

  return (
    <section className="py-10 pb-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-8">
          {features.map((feature, index) => (
            <FeatureIcon 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureIcon({ icon, title, description }: FeatureIconProps) {
  return (
    <div className="flex flex-col items-center text-center max-w-[340px]">
      <div className="mb-4 flex items-center justify-center w-28 h-28 rounded-full bg-blue-100">
        {icon}
      </div>
      <h3 className="text-2xl mb-6 text-blue-800 font-semibold">{title}</h3>
      <p className="text-blue-800 text-base leading-relaxed" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'normal' }}>{description}</p>
    </div>
  );
} 